import * as z from 'zod';

export type AccountingRangeFormSchemaValues = z.infer<typeof accountingRangeFormSchema>;
export const accountingRangeFormSchema = z
    .object({
        name: z.string().nonempty(),
        start: z.int().min(0),
        end: z.int().min(1),
        is_manual: z.boolean().optional(),
        billing_entity: z.string().nonempty(),
    });